import type { BigWinTuning, FeatureFinishedTuning, FeatureTriggerTuning } from "@slot/game-shell";
import type { CandyPanelMotionTuning } from "../views/CandyPanelMotion";
import type { BigWinMotionTuning } from "../views/big-win/BigWinView";

// The round panels' VALUES — the only file to edit to retune them. The shell's parts (the arm delays, the sounds and
// the music the presenters ask for, the big win's count-up) go whole to its presenters in createPresentation; the
// motion parts are the views'. The title ships no sounds yet: the ids below are the platform's names, silent until
// the title's audio bank registers them.

export const FEATURE_TRIGGER_TUNING: FeatureTriggerTuning = {
  armDelayMs: 800,
  openSoundId: "feature_trigger_panel_open",
  closeSoundId: "feature_trigger_panel_close",
  music: {
    idleId: "music_feature_idle",
    idleFadeInDelayMs: 400,
    idleFadeMs: 1500,
    loopId: "music_feature_free_spins",
    loopFadeMs: 1500,
  },
};

export const FEATURE_FINISHED_TUNING: FeatureFinishedTuning = {
  armDelayMs: 800,
  music: {
    idleId: "music_feature_idle",
    finishedIntroId: "music_feature_finished_intro",
    loopId: "music_feature_free_spins",
    loopFadeMs: 1500,
    baseId: "music_base",
  },
};

/** The tier breakpoints are the server's (`initialSettings.bigWinTiers`); this is how the panel counts and closes. */
export const BIG_WIN_TUNING: BigWinTuning = {
  autoCloseTimeoutMs: 5000,
  niceAutoCloseMs: 1200,
  instantTierReveal: false,
  niceTierNumberOnly: true,
  countUp: { baseSeconds: 1.8, perDigitSeconds: 0.6, maxSeconds: 8, minMs: 150, easing: "easeIn", easingExponent: 2 },
};

/** The trigger and finished cards: the dim under them, their pop in and shrink out, the hint. */
export const CANDY_PANEL_MOTION: CandyPanelMotionTuning = {
  dimInSeconds: 0.3,
  dimOutSeconds: 0.25,
  popSeconds: 0.45,
  popFromScale: 0.55,
  exitSeconds: 0.22,
  exitScale: 0.8,
  continueFadeInSeconds: 0.4,
  continueFadeOutSeconds: 0.2,
};

export const BIG_WIN_MOTION: BigWinMotionTuning = {
  dimInSeconds: 0.3,
  amountPopSeconds: 0.4,
  amountFromScale: 0.4,
  titlePopSeconds: 0.45,
  titleFromScale: 0.3,
  pulseSeconds: 0.6,
  pulseScale: 1.05,
  settleSeconds: 0.3,
  settleScale: 1.15,
  exitSeconds: 0.3,
  continueFadeInSeconds: 0.4,
  continueFadeOutSeconds: 0.2,
};
